export const RECOVERY_PASSWORD = 'RECOVERY_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const SEND_EMAIL = 'SEND_EMAIL';
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const HEAD = 'HEAD';
